import Service from '@ember/service';
import { service } from '@ember/service';
import RSVP from 'rsvp';

///////////////////////////////////////////////////////////////////////////////
// download - service for downloading design files                           //
///////////////////////////////////////////////////////////////////////////////

export default class DownloadService extends Service {
  @service('aditools-analytics') analytics;
  @service logger;
  @service('aditools-site') siteconfig;

  downloadDesign(downloadData) {
    return fetch(`${this.siteconfig.ApiUrl}/download/${this.siteconfig.AdiLocale}`, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Cache-Control': 'no-store',
      },
      method: 'POST',
      body: '"' + encodeURIComponent(JSON.stringify(downloadData)) + '"',
    })
      .then((response) => {
        if (response.ok) {
          let contentType = response.headers.get('Content-Type');
          let contentDisposition = response.headers.get('Content-Disposition');
          let fileName = '';
          if (contentDisposition && contentDisposition.indexOf('attachment') !== -1) {
            let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            let matches = filenameRegex.exec(contentDisposition);
            if (matches !== null && matches[1]) {
              fileName = matches[1].replace(/['"]/g, '');
            } else {
              fileName = 'DesignFiles.zip';
            }
          } else {
            fileName = 'DesignFiles.zip';
          }
          return RSVP.Promise.all([contentType, fileName, response.blob()]);
        } else {
          return RSVP.Promise.all(['', '', null]);
        }
      })
      .catch((error) => {
        this.logger.error(`Download failed: ${error}`);
        return RSVP.Promise.all(['', '', null]);
      });
  }
}
